import React, { Component } from "react";
import { withStore } from "store/storeHandler";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

/**
 * https://theqoo.net/square/298509638
 * https://en.wikipedia.org/wiki/Decimal_separator
 */

class FollowCountText extends Component {
  static propTypes = {
    type: PropTypes.oneOf(["following", "follower"]).isRequired,
    number: PropTypes.number.isRequired
  };

  static defaultProps = {};

  getLocales() {
    const { viewerLocation } = this.props;

    switch (viewerLocation) {
      case "KR":
        return "ko-KR";
      case "JP":
        return "ja-JP";
      case "CN":
        return "zh-CN";
      case "RU":
        return "ru-RU";
      case "IT":
        return "it-IT";
      case "ES":
        return "es-ES";
      case "DE":
        return "de-DE";
      case "FR":
        return "fr-FR";
      case "GB":
        return "en-GB";
      case "US":
      default:
        return "en-US";
    }
  }

  getNumbers() {
    const { number } = this.props;

    const style = { notation: "compact", roundingMode: "floor" };

    return new Intl.NumberFormat(this.getLocales(), style).format(number);
  }

  render() {
    const { type } = this.props;

    return (
      <span>
        {type === "following" && (
          <TXT
            name="btnFollowNum_following"
            input={{ count: this.getNumbers() }}
          />
        )}
        {type === "follower" && (
          <TXT
            name="btnFollowNum_follower"
            input={{ count: this.getNumbers() }}
          />
        )}
      </span>
    );
  }
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  }
})(FollowCountText);
